import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00b3df",
    },
    arrowIcon: {
      // main: "#fff",
    },
    button: {
      main: {
        active: {
          // background: "#00b3df",
          // text: "#fff",
        },
      },
      details: {
        normal: {
          // text: "#fff",
        },
        active: {
          // background: "#000",
          // text: "#fff",
        },
      },
    },
    text: {
      primary: "#333",
      main: "#fff",
      light: "#f7f7f7",
      tableItems: {
        main: "#fff",
        highlight: "#00b3df",
      },
      title: "#00b3df",
    },
    background: {
      main: "#fff",
      details: {
        main: "#012c36",
        highlight: "#013a47",
      },
    },
  },
  typography: {
    fontFamily: "Nunito Sans,Arial,sans-serif",
    h3: {
      fontWeight: 600,
      fontSize: "2.5rem",
      lineHeight: "2.75rem",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 787,
      md: 1024,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
